import React from 'react';
import { useStore } from 'effector-react';

import { Page } from 'src/ui/templates/page';
import { GroupsGrid } from 'src/ui/molecules/groups-grid';
import { CreateGroupButton } from 'src/features/home/ui/create-group-button';
import { favoriteGroups$, fetchFavoriteGroupsFx, groupFavoriteFx } from 'src/store/groups-collection.store';

export const FavoriteGroupsPage = () => {
	const groups = useStore(favoriteGroups$);

	return (
		<Page>
			<GroupsGrid
				groups$={favoriteGroups$}
				fetchGroupsFx={fetchFavoriteGroupsFx}
				onFavorite={async (payload) => {
					await groupFavoriteFx(payload);
					groups && fetchFavoriteGroupsFx({ page: groups.meta.page });
				}}
			/>
			<CreateGroupButton/>
		</Page>
	);
};
